export enum DataroomProvider {
    Syndtrak = 'Syndtrak',
    DebtDomain = 'DebtDomain',
    Intralinks = 'Intralinks',
    FinDox = 'FinDox',
}

export const dataroomProviderTitles: Record<DataroomProvider, string> = {
    [DataroomProvider.Syndtrak]: 'Syndtrak',
    [DataroomProvider.DebtDomain]: 'Debt Domain',
    [DataroomProvider.Intralinks]: 'Intralinks',
    [DataroomProvider.FinDox]: 'FinDox',
};
